import styled from 'styled-components';
import { getColor } from '@panel/commons/core/themev3';
import { select } from '@panel/commons/core/themev2';

const OptionContainer = styled.label`
  height: 40px;
  display: flex;
  flex-grow: ${({ flexWidth }) => (flexWidth ? 1 : 0)};
  padding: ${({ padding }) => padding};
  border-radius: 8px;
  border: 1px solid
    ${({ selected, disabled }) => {
      if (disabled) return select('midNeutralGray');
      if (selected) return getColor('primary');
      return select('midDarkGrayAux');
    }};
  background-color: ${({ selected, disabled }) => {
    if (disabled && selected) return select('neutralGray');
    if (selected) return getColor('tertiary');
    return 'transparent';
  }};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  transition: background-color 0.2s ease, border-color 0.2s ease;
  overflow: hidden;
  &:hover {
    background-color: ${({ selected, disabled }) => (!selected && !disabled ? select('neutralGray') : 'none')};
  }

  input {
    display: none;
  }

  .input-label {
    width: 100%;
    display: flex;
    justify-content: ${({ type }) => (type === 'checkbox' ? 'space-between' : 'center')};
    align-items: center;

    span {
      font-family: Hind;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: ${({ device }) => (device === 'tablet' ? '110px' : '100%')};
      color: ${({ disabled }) => (disabled ? select('midNeutralGray') : 'inherit')};
    }

    .check-icon {
      flex-shrink: 0;
      .iconSVG {
        margin-top: 4px;
        margin-left: 4px;
      }
    }
  }
`;

export { OptionContainer };
